import React, {Component} from "react";
import {connect} from "react-redux";
import KioskInactivityWarning from "../KioskInactivityWarning";
import {currentKioskWarningType} from "../../reducers/kioskWarningReducer";

const WARNING_COMPONENTS = {
    INACTIVITY_WARNING: KioskInactivityWarning,
};

class KioskWarningWrapper extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.warningType !== nextProps.warningType;
    }

    renderWarning = () => {
        const {warningType} = this.props;
        if (!warningType) {
            return null;
        }

        const SpecificWarning = WARNING_COMPONENTS[warningType];
        return <SpecificWarning/>;
    };

    render() {
        return <div>{this.renderWarning()}</div>;
    }
}

const mapStateToProps = state => {
    return {
        warningType: currentKioskWarningType(state)
    };
};

export default connect(mapStateToProps)(KioskWarningWrapper);



// WEBPACK FOOTER //
// ./src/components/KioskWarningWrapper/KioskWarningWrapper.jsx